import { Injectable } from '@angular/core';
/**
 * @return {?}
 */
function getWindow() {
    return window;
}
export class AmdWindowRef {
    /**
     * @return {?}
     */
    get nativeWindow() {
        return getWindow();
    }
}
AmdWindowRef.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
AmdWindowRef.ctorParameters = () => [];
function AmdWindowRef_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdWindowRef.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdWindowRef.ctorParameters;
}
//# sourceMappingURL=window-ref.service.js.map
//# sourceMappingURL=window-ref.service.js.map
